import React, { useEffect, useRef, useState } from 'react';
import http from '../../../Services/Http';
import { getCongressBillPageUrl } from '../../../utils/get-bill-url';
import Loading from '../../../Components/Loading';
import { useReveal } from '../../../Components/Fx/useReveal';

interface RepVotesProps {
   bioguideId: string;
}

const RepBills: React.FC<RepVotesProps> = ({ bioguideId }) => {
   const [bills, setBills] = useState<any[]>([]);
   const [loading, setLoading] = useState(true);
   const scope = useRef<HTMLUListElement>(null);

   useEffect(() => {
      setLoading(true);
      http.get(`reps/${bioguideId}/bills`).then(res => {
         setBills(res.data);
         setLoading(false);
      });
   }, [bioguideId]);

   useReveal(scope, [bills, loading]);

   if (loading) return <Loading label="Pulling legislation" />;

   if (!bills.length) return <p className="py-10 text-bone-muted">No sponsored legislation on record.</p>;

   return (
      <ul ref={scope} className="border-t border-white/[0.07]">
         {bills.map((item, i) => (
            <li key={item.url || i} data-reveal>
               <a
                  className="group grid grid-cols-[2.5rem_1fr] gap-4 border-b border-white/[0.07] py-6 transition-colors hover:bg-white/[0.02] md:grid-cols-[3rem_1fr_auto] md:gap-8"
                  href={getCongressBillPageUrl(item.url)}
                  target="_blank"
                  rel="noopener noreferrer"
               >
                  <span className="font-mono text-xs text-signal">{String(i + 1).padStart(2, '0')}</span>
                  <div className="min-w-0">
                     <p className="text-lg leading-snug text-bone transition-colors group-hover:text-white">
                        {item.title || item.latestAction?.text}
                     </p>
                     {item.latestAction?.actionDate && (
                        <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.14em] text-bone-dim">
                           Last action {item.latestAction.actionDate} {item.latestAction.actionTime}
                        </p>
                     )}
                     {item.text && <p className="mt-2 text-sm text-bone-muted">{item.text}</p>}
                     {item.summary && <p className="mt-2 text-sm text-bone-muted">{item.summary}</p>}
                  </div>
                  <div className="col-start-2 flex items-center gap-3 md:col-start-auto md:flex-col md:items-end">
                     {item.amendmentNumber ? (
                        <span className="chip border-amber-400/30 text-amber-200">Amdt {item.amendmentNumber}</span>
                     ) : (
                        item.billType && <span className="chip">{item.billType}</span>
                     )}
                     {item.introducedDate && (
                        <span className="font-mono text-[11px] text-bone-dim">
                           {new Date(item.introducedDate).toLocaleDateString()}
                        </span>
                     )}
                  </div>
               </a>
            </li>
         ))}
      </ul>
   );
};

export default RepBills;
